import React from 'react';

const Contact: React.FC = () => {
  return (
    <div className="bg-[#080808] text-white section-padding min-h-screen">
      <div className="container-responsive max-w-2xl">
        <h1 className="heading-responsive font-bold text-white mb-8 sm:mb-12 text-center tracking-tight">Kontakt</h1>

        <p className="text-base sm:text-lg leading-relaxed mb-6" style={{ color: 'rgba(255,255,255,0.65)' }}>
          Vil du booke Smuglergods til et arrangement, har du spørsmål om samarbeid, eller vil du bare snakke litt med en ekte Smugler? Vi hører gjerne fra deg.
        </p>

        <p className="text-base sm:text-lg leading-relaxed mb-6" style={{ color: 'rgba(255,255,255,0.65)' }}>
          Kontaktinformasjon kommer snart. I mellomtiden kan du nå oss via sosiale medier.
        </p>

        <p className="text-sm" style={{ color: 'rgba(255,255,255,0.35)' }}>
          — Smuglergods
        </p>
      </div>
    </div>
  );
};

export default Contact;